export default __webpack_public_path__ + "static/media/Might of the Wrathful.ed556fa3.jpg";